module.exports = __webpack_public_path__ + "media/svg/check-8d34e97c.svg";